import Head from "next/head"
import React from "react"
import DesktopLanding from "../components/pages/landing/desktop"
import MobileLanding from "../components/pages/landing/mobile"
import axios from "../lib/axios"
import { useMediaQuery, useTheme } from "@mui/material"

export default function Home({ merchantData }) {
  const theme = useTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down("md"), {
    noSsr: true
  })
  return (
    <>
      <Head>
        <title>جت وام | صفحه اصلی</title>
      </Head>

      {isMobile ? (
        <MobileLanding merchantData={merchantData} />
      ) : (
        <DesktopLanding merchantData={merchantData} />
      )}
    </>
  )
}

export async function getStaticProps() {
  let merchantData = null

  try {
    const MerchantList = await axios.get("/api/v1/merchant/getMainMerchantList")

    merchantData = MerchantList?.data?.value ?? null
  } catch (error) {
    console.error("Failed to fetch merchant list:", error?.message)
  }

  return {
    props: {
      merchantData
    }
  }
}